export default class PropertiesSortingService {

  initSortParams() {
    return {
      name: {
        sortDown: true,
        active: true
      },
      state: {
        sortDown: true,
        active: false
      },
      region: {
        sortDown: true,
        active: false
      },
      msa: {
        sortDown: true,
        active: false
      },
      available_spaces: {
        sortDown: true,
        active: false
      },
      // outlots: {
      //   sortDown: true,
      //   active: false
      // }
    }
  }

  setSortParams(app, sortButton) {
    const clickedButtonKey = sortButton.data('sort');
    const sortKeys = Object.keys(app.sortParams);
    let sortingParams = app.sortParams;
    if (app.sortParams[clickedButtonKey]['active']) {
      sortingParams[clickedButtonKey]['sortDown'] = !app.sortParams[clickedButtonKey]['sortDown'];
    }
    else {
      sortKeys.forEach(function(sortKey){
        sortingParams[sortKey]['active'] = false;
      });
      sortingParams[clickedButtonKey]['active'] = true;
    }
    return sortingParams;
  }

  sortProperties(properties, sortParams) {
    const activeKey = Object.keys(sortParams).find(function(sortKey){
      return sortParams[sortKey]['active'];
    }.bind(this));

    const activeValue = sortParams[activeKey];

    function sortFunctionDown(a, b) {
      switch (activeKey) {
        case 'available_spaces':
          const aLength = a.property_available_spaces.length - 1
          const bLength = b.property_available_spaces.length - 1
          return aLength - bLength
          break;
        // case 'outlots':
        //   const aHasOutlots = a['property_characteristics'].includes('land');
        //   const bHasOutlots = b['property_characteristics'].includes('land');
        //   return aHasOutlots > bHasOutlots;
        //   break;
        default:
          const aKey = a[activeKey] ? a[activeKey].toLowerCase() : '\uffff'; //final character lexicographically
          const bKey = b[activeKey] ? b[activeKey].toLowerCase() : '\uffff'; //final character lexicographically
          if (aKey < bKey)
            return -1;
          if (aKey > bKey)
            return 1;
          return 0;
      }
    };

    function sortFunctionUp(a, b) {

      switch (activeKey) {
        case 'available_spaces':
          const aLength = a.property_available_spaces.length - 1
          const bLength = b.property_available_spaces.length - 1
          return bLength - aLength
          break;
        // case 'outlots':
        //   const aHasOutlots = a['property_characteristics'].includes('land');
        //   const bHasOutlots = b['property_characteristics'].includes('land');
        //   return aHasOutlots < bHasOutlots;
        //   break;
        default:
          const aKey = a[activeKey] ? a[activeKey].toLowerCase() : '\uffff'; //final character lexicographically
          const bKey = b[activeKey] ? b[activeKey].toLowerCase() : '\uffff'; //final character lexicographically
          if (aKey > bKey)
            return -1;
          if (aKey < bKey)
            return 1;
          return 0;
      }
    };

    if (activeValue['sortDown']) {
      return properties.sort(sortFunctionDown);
    }
    else {
      return properties.sort(sortFunctionUp);
    }
  }

}



// WEBPACK FOOTER //
// ./web/src/app/javascripts/components/properties-app/PropertiesSortingService.jsx